import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initTheme } from './stores/themeStore';

// Apply persisted theme before first render to prevent flash of wrong theme
initTheme();

// Playwright test hooks — exposed on window so tests can inject store state and fake bounds
import { useSceneStore } from './stores/sceneStore';
import { getSpineManager } from './lib/spine-manager';
import { useToolStore } from './stores/toolStore';
import { usePlaybackStore } from './stores/playbackStore';
import { useOnionStore } from './stores/onionStore';
declare global {
  interface Window {
    __sceneStore: typeof useSceneStore;
    __getSpineManager: typeof getSpineManager;
    __toolStore: typeof useToolStore;
    __playbackStore: typeof usePlaybackStore;
    __onionStore: typeof useOnionStore;
  }
}
window.__sceneStore = useSceneStore;
window.__getSpineManager = getSpineManager;
window.__toolStore = useToolStore;
window.__playbackStore = usePlaybackStore;
window.__onionStore = useOnionStore;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
